<template>
  <el-dialog
    :visible.sync="dialogVisible.show"
    :close-on-click-modal="false"
    :close="close"
    width="30%"
  >
    <div>
      <h2 align="center">{{ article.Title }}</h2>
      <p
        class="article-info margin-bottom16"
        align="center"
      >
        <span class="date">{{ showPublish(article) }}</span>
        <span>来源:
          <a
            v-if="article.Url"
            :href="article.Url"
            target="_blank"
          >{{ article.DomainName }}</a>
          <span v-if="!article.Url">{{ article.DomainName }}</span>
        </span>
        <span v-if="article.Author">作者:
          <span>{{ article.Author }}</span>
        </span>
      </p>

      <div
        class="artical-content scroll-container"
        style=""
      >
        <div class="article-overview">
          <div v-if="article.DocumentAgent"> <b>发文机关:</b> {{ article.DocumentAgent }}</div>
          <div v-if="article.DocumentNumber"><b>发文字号: </b>{{ article.DocumentNumber }}</div>
          <div v-if="article.FileNumber"><b>档案号:</b> {{ article.FileNumber }}</div>
          <div v-if="article.Keywords && article.Keywords.length>0"><b>关键词:</b> {{ article.Keywords.join(',') }}</div>
          <div v-if="article.Summary"><b>摘要:</b> {{ article.Summary }}</div>

        </div>
        <div v-html="article.MainContent" />
      </div>

      <div
        v-if="article.Attachments && article.Attachments.length > 0"
        class="attach-list"
      >
        <span>附件:</span>
        <ul>
          <li
            v-for="item in article.Attachments"
            :key="item.StoreId"
          >
            <a @click="downAttachment(item.StoreId)">{{ item.FileName }}</a>
          </li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>
<script>
  import * as service from '@/service/httpService'
  export default {
    name: 'BreadCrumb',
    props: ['dialogVisible', 'article'],
    methods: {
      close () {
        this.delDialogVisible.show = false
      },
      showPublish (item) {
        return window.moment(item.PublishTime).format('YYYY-MM-DD')
      },
      downAttachment (storeId) {
        service.FileManageV2.download(storeId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/history/artile-dialog.vue